export default function VideoContent(props:{url:string}){
    return <div className="canvas">
        <video controls={true} muted={true} autoPlay={true}>
            <source src={props.url}/>
        </video>
    </div>
}